/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Errors_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} error" |
* | "other" | "{count} errors" |
*
* @param {Errors_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const errors_count = /** @type {((inputs: Errors_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} error`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} errors`);
		return /** @type {LocalizedString} */ ("errors_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} erreur`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} erreurs`);
		return /** @type {LocalizedString} */ ("errors_count");
	}
});